module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAUNJREFUWIXtlu1twjAQhp+LGIAR2IBsACOkG2QDxASEDbJCJyjZACZomQDYIEzw9o8rRWlsBRXHUsUrRbLPH/dc7iQfBCQpl/Sh5+siaQNgAecL4BOYhyD/qG0WWCwjOwfYhACm0CI1AMkBZpJ2nfm7mV0nBQCqzvwETAqQPAUvgBfAvwY4pQTYm9kaaGIB3IE3z1pjZpUbl8A5BkBhZgdg37OfnVMAzKx187v3pl6nsu7YK083U/XOH529lZR7fBS+1uhRgOPA5XPnvPBGGQjoEYBW0mCH5LMP7Dv0AR6pgcLl9Jd89gGV9IpyNvLgF7CStBq5P6QLsBwDcO2Mc/c9W423BmA4Z09UKykPpsDMCkklsIgQfW1mbfAPTKHkr2E/BUtJiuDn5u22JV0jFtqPKh9ZBtQRIh6tzMxqYAvcUgB8AwqlTjPwac5/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_menu_mosaic.png
// module id = 804
// module chunks = 1